import { render, staticRenderFns } from "./AdminTableHistory.vue?vue&type=template&id=4481358a"
import script from "./AdminTableHistory.vue?vue&type=script&lang=js"
export * from "./AdminTableHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminTableHistory.vue?vue&type=style&index=0&id=4481358a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports